// Pure helpers extracted from AgentCommission.js

export const fmtCurrency = (v) =>
  (v || 0).toLocaleString('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });

export const fmtDate = (d) => {
  if (!d) return '-';
  const dt = new Date(d);
  return dt.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: '2-digit' });
};

export const getFYOptions = () => {
  const now = new Date();
  const currentYear = now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1;
  const options = [];
  for (let i = 0; i < 3; i++) {
    const sy = currentYear - i;
    const ey = sy + 1;
    options.push({ label: `FY ${String(sy).slice(2)}-${String(ey).slice(2)}`, start: `${sy}-04-01`, end: `${ey}-03-31` });
  }
  return options;
};
